import React, { useState } from 'react';
import { Header, SpaceBetween, Tabs } from '@amzn/awsui-components-react-v3';
import { DATACONSUMER } from 'src/commons/constants';
import { BrowseTagBasedRequestsTable } from 'src/components/requests/browseTagBasedRequests';
import { BrowseResourceBasedRequestsTable } from 'src/components/requests/browseResourceBasedRequests';
import { signedInWithWorkspace } from 'src/components/dataadvisory/constants';
import { CommonPageProps } from 'src/components/common/CommonPageProps';
import { LakeFormationTable } from 'src/components/permissions/myPermissions/lakeFormation';
import { BrowseRequestsTable } from 'src/components/requests/browseRequests';

interface ListRequestsPageProps extends CommonPageProps {
  groupInfo: string | undefined;
  customerType: string;
}

export const ListRequestsPage = (props: ListRequestsPageProps) => {
  const [activeTabId, setActiveTabId] = useState(
    props.customerType === DATACONSUMER ? 'outgoingRequests' : 'incomingRequests',
  );

  const tabs = signedInWithWorkspace(props)
    ? [
        {
          label: 'Incoming',
          id: 'incomingRequests',
          content: (
            <SpaceBetween size='l'>
              <BrowseTagBasedRequestsTable {...props} isIncomingRequests={true} />

              <BrowseResourceBasedRequestsTable {...props} isIncomingRequests={true} />
            </SpaceBetween>
          ),
        },
        {
          label: 'Outgoing',
          id: 'outgoingRequests',
          content: (
            <SpaceBetween size='l'>
              <BrowseTagBasedRequestsTable {...props} isIncomingRequests={false} />

              <BrowseResourceBasedRequestsTable {...props} isIncomingRequests={false} />
            </SpaceBetween>
          ),
        },
      ]
    : [
        {
          label: 'Incoming',
          id: 'incomingRequests',
          content: (
            <SpaceBetween size='l'>
              <LakeFormationTable
                {...props}
                requestType='CreateLakeFormationGrantPermission'
                requestBoundOutgoing={false}
              />
              <BrowseRequestsTable {...props} isIncomingRequests={true} />
            </SpaceBetween>
          ),
        },
        {
          label: 'Outgoing',
          id: 'outgoingRequests',
          content: (
            <SpaceBetween size='l'>
              <LakeFormationTable
                {...props}
                requestType='CreateLakeFormationGrantPermission'
                requestBoundOutgoing={true}
              />
              <BrowseRequestsTable {...props} isIncomingRequests={false} />
            </SpaceBetween>
          ),
        },
      ];

  if (props.customerType === DATACONSUMER) {
    tabs.reverse(); // We want outgoing to be first for consumers
  }

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <Header variant={'h1'} description={'Use this page to browse incoming and outgoing requests for data access.'}>
        Access requests
      </Header>
      <Tabs
        tabs={tabs}
        activeTabId={activeTabId}
        variant='default'
        onChange={({ detail }) => {
          setActiveTabId(detail.activeTabId);
        }}
      />
    </SpaceBetween>
  );
};
